export const loadHomeDataAction = "Load Home Data Action";
